import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IApiToastMessageConfig, IInspection } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getInspectionUUID = createUUID();
const updateInspectionUUID = createUUID();

export const useInspection = () => {
  const stateManager = useComponentState();
  const [inspection, setInspection] = useState<IInspection | null>(null);

  const getInspection = async (id: string) => {
    stateManager.abort(getInspectionUUID);
    return stateManager.run(async () => {
      const response = await taskService.inspection.getById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setInspection(response.data);
      }
      return response;
    }, getInspectionUUID);
  };

  const updateInspection = async ({
    id,
    data,
    toastMessageConfig,
  }: {
    id: string;
    data: Partial<IInspection>;
    toastMessageConfig?: IApiToastMessageConfig;
  }) => {
    stateManager.abort(updateInspectionUUID);
    return stateManager.run(async () => {
      const response = await taskService.inspection.update({
        id,
        data,
        toastMessageConfig,
      });
      return response;
    }, updateInspectionUUID);
  };

  const updateInspectionNotes = async ({
    id,
    notes,
    modifiedOn,
  }: {
    id: string;
    notes: string;
    modifiedOn: string;
  }) => {
    return updateInspection({
      id,
      data: {
        notes,
        modifiedOn,
      },
      toastMessageConfig: {
        success: { text: "Inspection notes updated successfully." },
      },
    });
  };

  return {
    inspection,
    getInspection,
    updateInspection,
    updateInspectionNotes,
    isLoading: stateManager.isBusy(),
  };
};
